module.exports = __webpack_public_path__ + "img/EgyptTechAxemanS_ua.c143b793.webp";